import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <div style={{height: "60vh", position: "relative"}}>
      <div style={{position: "absolute", left: "50%", top: "40%", transform: "translate(-50%, -50%)"}}>
    <h1>Nie znaleziono takiego adresu!</h1>
    <p>Wróć na <a href="https://willbud.pl/">Stronę główną</a></p>

      </div>
    </div>
  </Layout>
)

export default NotFoundPage
